<div class="page-wraper bg-gray-50" appSpin [spinnerConfig]="spinnerConfig()">
    <header
        class="d-flex flex-wrap flex-column flex-lg-row align-items-lg-center justify-content-between gap-8 bg-primary p-3">
        <div class="header-left d-flex flex-column flex-lg-row flex-wrap align-items-lg-center gap-8">
            <div class="flexbox-row gap-8 w-auto align-self-start">
                <ngx-avatars initialsSize="1" size="22" bgColor="#ffffff" fgColor="#3373a5" name="c" [round]="false"
                    [textSizeRatio]="1.4"></ngx-avatars>

                <h6 class="title text-white" title="{{engagementInfo()?.engType}}">{{ engagementInfo()?.engType }}
                </h6>
            </div>
            <p class="text-white">Engagement Name: <b>{{ engagementInfo()?.engagementName }}</b></p>
        </div>

        <div class="header-middle">
            <p class="text-white">Client Name: <b>{{ engagementInfo()?.clientName }}</b></p>
        </div>

        <div class="header-right">
            <p class="text-white">Year End Date: <b>{{ engagementInfo()?.yearEnd }}</b></p>
        </div>
    </header>
    <mat-drawer-container class="countable-drawer attachable-drawer">
        <mat-drawer-content>
            <div class="page-wraper bg-gray-50 d-flex">
                <div class="page-title-block flexbox-column gap-4">
                    <span class="d-flex gap-12 align-items-center">
                        <h1 class="h3">Source Docs</h1>
                         <span class="d-inline-block border br-12 p-2"
                        style="min-width: 80px; text-align: center;"><img
                            class="task" style="height: 20px;" [src]="sourceImage()"></span>
                    </span>

                    <p> Search and download documents from connected source.</p>

                </div>
                <div class="content-block-main attachable-header">
                    <div class="flexbox-row pb-24 justify-content-between align-items-end attachable-action"
                        [ngClass]="{'flex-wrap' : isToggleExpanded}">
                        <div class="flexbox-row gap-10 align-items-end">
                            <!-- <div class="d-flex flex-column gap-8">
                                <h6>
                                    Source
                                </h6>
                                <button mat-button mat-stroked-button class="disabled source-btn"
                                    color="dark"><span class="button-label">{{source() ? source() : 'Source'}} </span><i
                                        class="fa-regular fa-angle-down"></i>
                                </button>
                            </div> -->
                            <div class="d-flex flex-column gap-8">
                                <h6>Select Category</h6>
                                <button mat-button mat-stroked-button class="select-cat-btn"
                                    [ngClass]="{'selected-option': !!categoryCount() }"
                                    [matMenuTriggerFor]="categoryFilterMenu" color="dark"><span
                                        class="button-label">Category ({{ categoryCount() }}) </span><i
                                        class="fa-regular fa-angle-down"></i>
                                </button>
                                <mat-menu #categoryFilterMenu="matMenu" #beforeMenu="matMenu" xPosition="after"
                                    panelClass="my-select-panel-class select-status" class="category-dropdown">
                                    <div class="flexbox-row flex-nowrap gap-8 p-2 pb-0"
                                        (click)="$event.stopPropagation()">
                                        <mat-form-field class="fixed-label label-none w-100 icon-field-before"
                                            floatLabel="always">
                                            <mat-label>Search Category</mat-label>
                                            <input class="bg-white shadow-none" matInput placeholder="Search Category"
                                                (click)="$event.stopPropagation()" [formControl]="categoryCtrl">
                                            <span matPrefix>
                                                <i class="fa-regular fa-magnifying-glass"></i>
                                            </span>
                                        </mat-form-field>
                                    </div>
                                    <div class="d-flex w-100 p-2">
                                        <button mat-button class="button-text w-100 text-start"
                                            (click)="selectAllCategories();$event.stopPropagation();">Select All
                                        </button>
                                        <button mat-button class="button-text w-100 text-end justify-content-end"
                                            (click)="clearCategories();$event.stopPropagation();">Clear All
                                        </button>
                                    </div>
                                    <div class="scrollable-block border-top">
                                        @for (row of filteredCategories(); track row?.value) {
                                        <button mat-menu-item (click)="$event.stopPropagation()"
                                            [ngClass]="{'selected-option': selectedCategories().has(row?.value)}"
                                            style="cursor: default !important;">
                                            <mat-checkbox [checked]="selectedCategories().has(row?.value)"
                                                (change)="toggleCategory(row?.value)">
                                                {{ row?.name }}
                                            </mat-checkbox>
                                        </button>
                                        }
                                    </div>

                                </mat-menu>
                            </div>


                            <div class="d-flex flex-column gap-8">
                                <h6>Select Period</h6>
                                <button mat-button mat-stroked-button class="period-btn"
                                    [ngClass]="{'selected-option': !!selectedYearCount() }"
                                    [matMenuTriggerFor]="periodMenu" color="dark"><span class="button-label">Period
                                        ({{ selectedYearCount() }}) </span><i class="fa-regular fa-angle-down"></i>
                                </button>
                                <mat-menu #periodMenu="matMenu" #beforeMenu="matMenu" xPosition="after"
                                    panelClass="my-select-panel-class select-status">
                                    <mat-radio-group [value]="selectedYears()" (change)="toggleYearType($event.value)">
                                        @for (row of engYearDetails(); track $index) {
                                        <div mat-menu-item (click)="$event.stopPropagation()" style="cursor: default !important;">
                                            <mat-radio-button [value]="row?.acctdate">
                                                {{ row?.acctdate }}
                                            </mat-radio-button>
                                        </div>
                                        }
                                    </mat-radio-group>
                                </mat-menu>
                            </div>

                            <div class="form-item fixed-label icon-field-after attach-date-field">
                                <app-countable-date [label]="'Start Date'" [isRequired]="true" [isMinDate]="true" [isMaxDate]="true"
                                (selectedDate)="onChangeStartDate($event)" [inputDate]="periodMinDate()" [isDisabled]="isDateDisabled()"
                                   [inputMinDate]="periodMinDate()" [inputMaxDate]="periodMaxDate()" [placeholderText]="'MM/DD/YYYY'"></app-countable-date>
                            </div>
                            <div class="form-item fixed-label icon-field-after attach-date-field">
                                <app-countable-date [label]="'End Date'" [isRequired]="true" [isMinDate]="true" [isMaxDate]="true"
                                  (selectedDate)="onChangeEndDate($event)" [inputDate]="periodMaxDate()" [isDisabled]="isDateDisabled()"
                                    [inputMinDate]="periodMinDate()" [inputMaxDate]="periodMaxDate()" [placeholderText]="'MM/DD/YYYY'"></app-countable-date>
                            </div>
                            <button mat-button mat-flat-button color="primary" [disabled]="isSubmitDisabled()"
                                (click)="getSelectedAttachable()">Submit
                            </button>
                        </div>
                        <div class="flexbox-row gap-10">
                            @if (!isToggleExpanded || (windowWidth<=1600 && isToggleExpanded)) {
                            <mat-form-field floatLabel="always"
                                class="fixed-label label-none icon-form-before btn-search-matfield-tmp ms-auto">
                                <mat-label>Search</mat-label>
                                <input matInput placeholder="Search" [value]="searchAttachable()"
                                    (input)="searchInAttachable($event)" />
                                <span matPrefix>
                                    <i class="fa-regular fa-magnifying-glass text-primary-darker" draggable="false"></i>
                                </span>
                            </mat-form-field>
                            @if(!isShowSelected()){
                            <button mat-button mat-stroked-button color="dark"
                                (click)="isShowSelected.set(true); searchAttachable.set('');"
                                [disabled]="!selectedAttachable().size"><i
                                    class="fa-regular fa-square-check fs-20"></i><span class="button-label"> Show
                                    Selected </span>
                            </button>
                            } @else {
                            <button mat-button mat-stroked-button color="dark" (click)="isShowSelected.set(false)"><i
                                    class="fa-regular fa-table-cells-large fs-20"></i><span class="button-label"> Show
                                    All </span>
                            </button>
                            }
                            <button mat-button mat-flat-button [disabled]="!selectedAttachable().size"
                                [matMenuTriggerFor]="saveDocsMenu" color="primary"><i
                                    class="fa-regular fa-floppy-disk fs-20"></i><span class="button-label">Save Docs
                                </span>
                            </button>
                            <mat-menu #saveDocsMenu="matMenu" #beforeMenu="matMenu" xPosition="after"
                                panelClass="my-select-panel-class select-status">
                                <button mat-menu-item (click)="downloadToComputer()">Download to Computer</button>
                                <button mat-menu-item (click)="saveToEngagement()">Save To Engagement</button>
                            </mat-menu>
                            }
                            @else{

                            <div class="expandable-search self-align-end" title="Search"
                                [ngClass]="{'expanded':isSearchInput}">
                                <mat-form-field class="fixed-label label-none icon-field-left" floatLabel="always">
                                    <mat-label>Search</mat-label>
                                    <input matInput #tbGridSearchInput maxlength="50" matInput placeholder="Search"
                                        [value]="searchAttachable()" (input)="searchInAttachable($event)" type="text"
                                        autocomplete="off">
                                    <span matPrefix>
                                        <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
                                    </span>
                                </mat-form-field>

                                <button mat-button mat-stroked-button color="dark" class="button-default-icon"
                                    type="button" title="Search" (click)="setFocus()" *ngIf="!isSearchInput">
                                    <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
                                </button>
                                <button mat-button mat-stroked-button color="dark" class="button-default-icon"
                                    type="button" title="Close"
                                    (click)="tbGridSearchInput.value = ''; clearSearchField()" *ngIf="isSearchInput">
                                    <i class="fa-regular fa-xmark text-error"></i>
                                </button>
                            </div>

                            @if(!isShowSelected()){
                            <button mat-button mat-stroked-button color="dark" title="Show Selected" class="button-default-icon"
                                (click)="isShowSelected.set(true); searchAttachable.set('');"
                                [disabled]="!selectedAttachable().size"><i class="fa-regular fa-square-check fs-20"></i>
                            </button>
                            } @else {
                            <button mat-button mat-stroked-button color="dark" class="button-default-icon" title="Show All"
                                (click)="isShowSelected.set(false)"><i
                                    class="fa-regular fa-table-cells-large fs-20"></i>
                            </button>
                            }
                            <button mat-button mat-flat-button [disabled]="!selectedAttachable().size" title="Save Docs"
                                [matMenuTriggerFor]="saveDocsMenu" color="primary" class="button-default-icon"><i
                                    class="fa-regular fa-floppy-disk fs-20"></i>
                            </button>
                            <mat-menu #saveDocsMenu="matMenu" #beforeMenu="matMenu" xPosition="after"
                                panelClass="my-select-panel-class select-status">
                                <button mat-menu-item (click)="downloadToComputer()">Download to Computer</button>
                                <button mat-menu-item (click)="saveToEngagement()">Save To Engagement</button>
                            </mat-menu>
                            }
                        </div>
                    </div>
                    <div class="h-100 overflow-auto card">
                        @if(!isFormSubmit()){
                        <div class="no-data-found w-100">
                            <img src="./assets/images/ui-uplift-icons/global/empty-component-icon.svg" alt="Icon">
                            <h6>No category and period selected yet.</h6>
                        </div>
                        } @else{
                        <div class="flex-table fixed-header w-100 bot-engagement-table h-100">
                            <div class="flex-table-header">
                                <span class="ft-header-cell account-cell width-40">
                                    <mat-checkbox [checked]="isAllSelected()" (change)="toggleAllAttachable($event)">
                                    </mat-checkbox>
                                </span>

                                <p class="ft-header-cell account-cell ps-2 name-width">Name</p>
                                <span class="ft-cell account-cell ps-2 width-320 text-center" title="Category">
                                    Category
                                    <button mat-button class="mat-icon-button" [matMenuTriggerFor]="catFilterMenu"><i
                                            class="fa-solid fa-bars-filter text-gray-6 fs-15"></i></button>
                                </span>
                                <mat-menu #catFilterMenu="matMenu" #beforeMenu="matMenu" xPosition="after"
                                    panelClass="my-select-panel-class select-status" class="cust-dropdown">
                                    <div class="d-flex w-100 p-2" (click)="$event.stopPropagation()">
                                        <button mat-button class="button-text w-100 text-end justify-content-end"
                                            (click)="clearAttachableCategories()">Clear
                                            All
                                        </button>
                                    </div>
                                    @for (row of attachableCategories(); track row) {
                                    <button mat-menu-item (click)="$event.stopPropagation()"
                                        [ngClass]="{'selected-option': selectedAttachableCategories().has(row)}"
                                        style="cursor: default !important;">
                                        <mat-checkbox [checked]="selectedAttachableCategories().has(row)"
                                            (change)="toggleAttachableCategory(row)">
                                            {{ row }}
                                        </mat-checkbox>
                                    </button>
                                    }
                                </mat-menu>
                                <span class="ft-cell account-cell ps-2 width-320 text-center" title="Type">
                                    Type

                                    <button mat-button [matMenuTriggerFor]="typeFilterMenu" class="mat-icon-button"><i
                                            class="fa-solid fa-bars-filter text-gray-6 fs-15"></i></button>
                                    <button mat-button [matMenuTriggerFor]="typeSortMenu"
                                        class="mat-icon-button ps-0 justify-content-start"><i
                                            class="fa-regular fa-arrow-up-arrow-down text-gray-6 fs-15"></i></button>


                                </span>
                                <mat-menu #typeFilterMenu="matMenu" #beforeMenu="matMenu" xPosition="after"
                                    panelClass="my-select-panel-class select-status" class="type-dropdown">
                                    <div class="d-flex w-100 p-2" (click)="$event.stopPropagation()">
                                        <button mat-button class="button-text w-100 text-end justify-content-end"
                                            (click)="clearAttachableFileType()">Clear
                                            All
                                        </button>
                                    </div>
                                    @for (row of attachableFileTypes(); track row) {
                                    <button mat-menu-item (click)="$event.stopPropagation()"
                                        [ngClass]="{'selected-option': selectedAttachableFileTypes().has(row)}"
                                        style="cursor: default !important;">
                                        <mat-checkbox [checked]="selectedAttachableFileTypes().has(row)"
                                            (change)="toggleFileType(row)">
                                            {{ row | uppercase }}
                                        </mat-checkbox>
                                    </button>
                                    }
                                </mat-menu>
                                <mat-menu #typeSortMenu="matMenu" #beforeMenu="matMenu" xPosition="after">
                                    <button mat-menu-item [ngClass]="{'selected' : typeSelectedSortType() === 'ASC'}"
                                        (click)="sortAttachableType('ASC')"><i
                                            class="fa-regular fa-arrow-up-long"></i>Ascending Order
                                    </button>
                                    <button mat-menu-item [ngClass]="{'selected' : typeSelectedSortType() === 'DESC'}"
                                        (click)="sortAttachableType('DESC')">
                                        <i class="fa-regular fa-arrow-down-long"></i>Descending Order
                                    </button>
                                </mat-menu>
                                <span class="ft-cell account-cell ps-5 width-250" title="Type">
                                    Size
                                    <button mat-button [matMenuTriggerFor]="sizeFilterMenu" class="mat-icon-button"><i
                                            class="fa-regular fa-arrow-up-arrow-down text-gray-6 fs-15"></i></button>
                                </span>
                                <mat-menu #sizeFilterMenu="matMenu" #beforeMenu="matMenu" xPosition="after">
                                    <button mat-menu-item [ngClass]="{'selected' : selectedSortType() === 'ASC'}"
                                        (click)="sortAttachable('ASC')"><i
                                            class="fa-regular fa-arrow-up-long"></i>Ascending Order
                                    </button>
                                    <button mat-menu-item [ngClass]="{'selected' : selectedSortType() === 'DESC'}"
                                        (click)="sortAttachable('DESC')">
                                        <i class="fa-regular fa-arrow-down-long"></i>Descending Order
                                    </button>
                                </mat-menu>

                            </div>
                            <div class="flex-table-body h-100">
                                @for (row of attachableList(); track row?.id) {
                                <div class="ft-row button-row tb-source-row"
                                    [ngClass]="{'selected': selectedAttachable().has(row?.id)}">
                                    <span class="ft-cell account-cell width-40">
                                        <mat-checkbox [checked]="selectedAttachable().has(row?.id)"
                                            (change)="toggleAttachable(row?.id)">
                                        </mat-checkbox>
                                    </span>
                                    <p class="ft-cell account-cell ps-2 name-width" title="{{row?.name}}">
                                        <a href="javascript:void(0)" (click)="previewAttachable(row);isToggleExpanded = true"
                                            class="clickable-link">
                                            {{ row?.name }}
                                        </a>
                                    </p>
                                    <p class="ft-cell account-cell ps-2 width-320 text-center pe-5"
                                        title="{{row?.category}}">
                                        {{ row?.category }}
                                    </p>
                                    <p class="ft-cell account-cell ps-2 width-320 text-center type-column-padding"
                                        title="{{row?.extension}}">
                                        {{ row?.extension | uppercase }}
                                    </p>
                                    <p class="ft-cell account-cell ps-5 width-250" title="{{row?.size}}">
                                        {{ row?.size }}
                                    </p>
                                </div>
                                } @empty {
                                <div class="no-data-found w-100">
                                    <img src="./assets/images/ui-uplift-icons/global/empty-component-icon.svg"
                                        alt="Icon">
                                    <h6>No data found. Modify search and try again.</h6>
                                </div>
                                }
                            </div>
                        </div>
                        }
                    </div>
                    @if (totalAttachable()) {
                    <div class="pt-2">
                        <h6 class="text-gray-7">{{ totalAttachable() }} Total documents</h6>
                    </div>
                    }
                </div>
            </div>
        </mat-drawer-content>
        <mat-drawer #drawer class="order-2 drawer-from-right prev-right-drawer">
            <div class="toogle-button-block button-block-right">
                <button mat-button class="button-small-icon toogle-button w-100"
                    (click)="drawer.toggle();toggleDrwaer()"></button>
                <div class="toogle-content">
                    <h6 class="title">Preview</h6>
                </div>
            </div>
            <div class="content-block w-100">
                <div class="h-100">
                    @if (previewUrl && isPreviewableFile()) {
                    @if(isMsDocument()){
                    <iframe [src]="previewUrl" frameborder="0" style="width:100%;height:100%"></iframe>
                    } @else {
                    @switch (fileType()) {
                    @case ('pdf') {
                    <iframe [src]="previewUrl" frameborder="0" style="width:100%;height:100%"></iframe>
                    }
                    @case ('jpg') {
                    <img [src]="previewUrl" />
                    }
                    @case ('jpeg') {
                    <img [src]="previewUrl" />
                    }
                    @case ('png') {
                    <img [src]="previewUrl" />
                    }
                    @case ('gif') {
                    <img [src]="previewUrl" />
                    }

                    @case ('bmp') {
                    <img [src]="previewUrl" />
                    }
                    @case ('svg') {
                    <img [src]="previewUrl" />
                    }
                    @case ('txt') {
                    <iframe [src]="previewUrl" frameborder="0" style="width:100%;height:100%"></iframe>
                    }
                    @case ('xml') {
                    <iframe [src]="previewUrl" frameborder="0" style="width:100%;height:100%"></iframe>
                    }
                    @case ('json') {
                    <iframe [src]="previewUrl" frameborder="0" style="width:100%;height:100%"></iframe>
                    }
                    @default {
                    <p>Preview not available.</p>
                    }
                    }
                    }
                    } @else if (previewUrl && !isPreviewableFile()) {
                    <div class="fallback-preview">
                        <p>Preview not available for this file. Please download instead.</p>
                        <button mat-button mat-flat-button color="primary" (click)="downloadBlob()">Download
                            File</button>
                    </div>
                    } @else {
                    <div class="no-data-found w-100">
                        <img src="./assets/images/ui-uplift-icons/global/empty-component-icon.svg" alt="Icon">
                        <h6>No Attachable Selected For Preview</h6>
                    </div>
                    }

                </div>
            </div>

        </mat-drawer>

    </mat-drawer-container>
</div>


<ng-template #errorDialog>
    <div class="countable-dialog confirmation-dailog" (click)="$event.stopPropagation()">
        <div mat-dialog-title class="dialog-header">
            <span class="badge badge-error badge-circle icon-bordered-error">
                <i class="fa-regular fa-circle-exclamation text-error"></i>
            </span>
            <h4 class="title">Document Sync Limit</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="dialog-body-content pt-2">
            <!-- <p>{{ errorMessage() }}</p> -->
            <p>For performance reasons, only 60 documents can be pulled per minute.</p>
            <p>Please modify date range to narrow your results and avoid delays.</p>
        </div>

        <div mat-dialog-actions class="dialog-footer button-group w-100">
             <button mat-button mat-flat-button class="flex-1" color="primary"
                [mat-dialog-close]="true">Ok</button>
        </div>
    </div>
</ng-template>
